export class StorageService {

  constructor(storage) {
    this.storage = storage;
  }

  static getInstance() {
    if (this.instance == null) {
      StorageService.instance = new StorageService(sessionStorage);
    }
    return this.instance;
  }
  
  get(item) {
    let result = null;
  
    if (this.storage.length > 0) {
      const sessionStorageItem = this.storage.getItem(item);
  
      if (sessionStorageItem) {
        let objItem = JSON.parse(sessionStorageItem);
        const expiration = objItem && objItem.expiration ? objItem.expiration : null;
  
        if (expiration) {
          const now = new Date().getTime();
  
          if (now >= expiration) {
            this.remove(item);
            objItem = null;
          }
        }
  
        result = objItem ? objItem.val : objItem;
      }
    }
  
    return result;
  }
  
  set(item, value, expiration) {
    const objItem = {
      val: value,
      expiration: 0
    };
  
    if (expiration) {
      objItem.expiration = expiration;
    }
  
    const objStringified = JSON.stringify(objItem);
  
    this.storage.setItem(item, objStringified);
  }
  
  remove(item) {
    if (this.storage.length > 0) {
      this.storage.removeItem(item);
    }
  }
}
